import { createAction } from 'redux-actions'

import { LOAD_USER_STATE } from './constants'

export const loadUserState = createAction(LOAD_USER_STATE)
